import CompetitiveEdge from '../../assets/images/opportunity/CompetitiveEdge.svg'
import EndToEnd from '../../assets/images/opportunity/EndToEnd.svg'
import SmarterInnovation from '../../assets/images/opportunity/SmarterInnovation.svg'

export const OpportunitySubheadData = [
  {
    img: SmarterInnovation,
    title: 'Smarter Innovation',
    description:
      'The right innovation approach in the right markets reveals learnings from start to finish, leading to a higher probability of success.',
  },
  {
    img: CompetitiveEdge,
    title: 'Competitive Edge',
    description:
      'Different is awesome. Differentiation vs following the industry unlocks new opportunities and solidifies our role as leaders in recruiting consumers.',
  },
  {
    img: EndToEnd,
    title: 'End-to-End System Value',
    description:
      'Drive bolder and more impactful innovations supported by the right investments and forceful margin expansion.',
  },
]
